import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { BookOpen, Plus } from "lucide-react";
import { PublicAccessNotice } from "@/components/PublicAccessNotice";

export default function ProductsHub() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products/categories")
      .then(({ data }) => setCategories(data))
      .catch(() => setCategories([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="bg-[#FAF9F6]">
      {/* HEADER */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10">
        <p className="label-eyebrow text-[#C05C45]">Libri & Giochi educativi</p>
        <h1 className="mt-3 font-display text-4xl sm:text-5xl lg:text-6xl text-[#1A362D] tracking-tight leading-[1.05]">
          Risorse scelte<br />dai genitori, per i genitori.
        </h1>
        <p className="mt-6 font-ui text-base sm:text-lg text-[#5C6B64] leading-relaxed max-w-2xl">
          Una piccola selezione editoriale di libri, giochi e strumenti per crescere bene insieme nei primi anni —
          organizzata per i temi che riguardano davvero il quotidiano in famiglia.
        </p>
        <p className="mt-3 font-ui text-base sm:text-lg text-[#1A362D] leading-relaxed max-w-2xl">
          Ma l'idea vera è che <strong>tu possa contribuire con risorse nuove</strong> che ti hanno ispirato e che
          vorresti consigliare ad altri genitori.
        </p>

        <div className="mt-8 flex flex-wrap gap-3">
          <Link
            to="/consiglia-materiale"
            data-testid="suggest-product-cta"
            className="btn-secondary inline-flex items-center gap-2"
          >
            <Plus size={16} /> Consiglia materiale educativo
          </Link>
        </div>

        <div className="mt-8 max-w-2xl">
          <PublicAccessNotice context="products" />
        </div>
      </section>

      {/* CATEGORIES GRID */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-24">
        {loading ? (
          <p className="font-ui text-[#8A9691]">Caricamento aree…</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/prodotti/${c.slug}`}
                data-testid={`category-card-${c.slug}`}
                className="group relative bg-white border border-[#E8E6E1] rounded-xl p-6 hover:-translate-y-1 hover:shadow-[0_12px_32px_-16px_rgba(26,54,45,0.2)] transition-all duration-300 overflow-hidden"
              >
                <div
                  className="absolute -top-8 -right-8 w-32 h-32 rounded-full opacity-20 group-hover:opacity-30 transition-opacity"
                  style={{ background: c.hex || "#C05C45" }}
                  aria-hidden
                />
                <div className="relative">
                  <div className="text-4xl" aria-hidden>{c.emoji}</div>
                  <h2 className="mt-4 font-display text-xl text-[#1A362D] leading-tight">{c.label}</h2>
                  <p className="mt-2 font-ui text-xs text-[#5C6B64] leading-relaxed line-clamp-2">
                    {c.tagline}
                  </p>
                  <p className="mt-4 font-ui text-xs font-semibold text-[#C05C45] inline-flex items-center gap-1">
                    <BookOpen size={13} /> {c.product_count} {c.product_count === 1 ? "prodotto" : "prodotti"}
                  </p>
                </div>
              </Link>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
